<template>
  <section v-if="topProducts.length" class="topsell__area-1 pt-15 top-deals-uniform">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section__head d-flex justify-content-between mb-10">
            <div class="section__title">
              <h5 class="st-titile-d">Top Deals Of The Day</h5>
            </div>
            <router-link to="/shop" class="td-view-all">
              View All <i class="fas fa-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="product-bs-slider">
            <swiper :modules="modules" class="product-slider swiper-container" v-bind="sliderSetting">
              <swiper-slide v-for="product in topProducts" :key="product.id">
                <product-single
                  :product="product"
                  :uniform-size="true"
                  :deal-end-date="product.end_date_time || ''"
                ></product-single>
              </swiper-slide>
            </swiper>
            <div class="bs-button bs-button-prev"><i class="fas fa-chevron-left"></i></div>
            <div class="bs-button bs-button-next"><i class="fas fa-chevron-right"></i></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import ProductSingle from '@/components/product/product-single.vue';

export default {
  name: "TopDeals",
  components: {
    Swiper,
    SwiperSlide,
    ProductSingle,
  },
  data() {
    return {
      modules: [Navigation],
      topProducts: [],
      sliderSetting: {
        slidesPerView: 1,
        spaceBetween: 12,
        navigation: {
          nextEl: '.bs-button-next',
          prevEl: '.bs-button-prev',
        },
        breakpoints: {
          550: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1400: { slidesPerView: 5 },
        }
      }
    };
  },
  methods: {
    async fetchDailyDeals() {
      try {
        const response = await this.$axios.get(`/daily-deals-products`);
        const now = Date.now();
        this.topProducts = (response.data || []).filter((p) => {
          if (!p.end_date_time) return true;
          return new Date(p.end_date_time).getTime() > now;
        });
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
  },
  mounted() {
    this.fetchDailyDeals();
  },
};
</script>

<style scoped>
/* ── Section header ─────────────────────────────── */
.td-view-all {
  font-size: 14px;
  font-weight: 600;
  color: var(--fe-accent, #fcbe00);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}
.td-view-all:hover {
  color: var(--fe-accent-hover, #e5ac00);
}

/* ── Product slider ─────────────────────────────── */
:deep(.product-slider .swiper-slide) {
  height: auto;
  display: flex;
}

:deep(.top-deals-uniform .product__item) {
  height: 100%;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
}

:deep(.top-deals-uniform .product__thumb) {
  min-height: 220px;
}

:deep(.top-deals-uniform .product__thumb .product-image) {
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.top-deals-uniform .product__thumb .product-image a) {
  width: 170px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.top-deals-uniform .product__thumb .product-image img) {
  max-width: 170px;
  max-height: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
}

:deep(.top-deals-uniform .product__content) {
  min-height: 110px;
  padding-bottom: 70px;
}

:deep(.top-deals-uniform .product__add-cart) {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  bottom: 60px;
}

/* Slider nav arrows */
.product-bs-slider {
  position: relative;
}

:deep(.bs-button) {
  visibility: visible !important;
  opacity: 1 !important;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  z-index: 10;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  color: #334155;
  font-size: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

:deep(.bs-button:hover) {
  background: var(--fe-accent, #fcbe00);
  border-color: var(--fe-accent, #fcbe00);
  color: #fff;
  box-shadow: 0 4px 14px rgba(252, 190, 0, 0.35);
}

:deep(.bs-button-prev) {
  left: -16px;
}

:deep(.bs-button-next) {
  right: -16px;
}

@media (max-width: 1399px) {
  :deep(.bs-button-prev) { left: -8px; }
  :deep(.bs-button-next) { right: -8px; }
}

@media (max-width: 767px) {
  :deep(.bs-button) {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
  :deep(.bs-button-prev) { left: -4px; }
  :deep(.bs-button-next) { right: -4px; }
}
</style>
